import { render } from "./ItemInformationCard.vue?vue&type=template&id=426aa401&scoped=true"
import script from "./ItemInformationCard.vue?vue&type=script&lang=js"
export * from "./ItemInformationCard.vue?vue&type=script&lang=js"

import "./ItemInformationCard.vue?vue&type=style&index=0&id=426aa401&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426aa401"]])

export default __exports__